import { getUAResult } from '../shared';
export const osMeta = () => {
    const { name, version } = getUAResult().os;
    if (!name && !version) {
        return {};
    }
    const os = {};
    if (name) {
        os.name = name;
    }
    if (version) {
        os.version = version;
    }
    return { os };
};
//# sourceMappingURL=meta.js.map